import script from "./ReadReceiptsPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReadReceiptsPopover.vue?vue&type=script&setup=true&lang=ts"

import "./ReadReceiptsPopover.vue?vue&type=style&index=0&id=041e96bf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-041e96bf"]])

export default __exports__